<template>
  <v-app>  
    <Toolbar/>  
    <SystemBar class="systembarFix"/>    
    <v-main id="appContent">   
      
      <DialogProyecto/>
      
      <DialogSignature/>
      <DialogSignatureCustomer/>
      <DialogSignatureHourStart/>
      <DialogSignatureHourEnd/>
      
      <DialogExtraInfo/>
      <DialogSummary/>
      <DialogDocumentImages/>
      <DialogLogout/>
      <router-view/>
    </v-main>
  </v-app>
</template>
<script>
import Toolbar from '@/components/Toolbar.vue'
//import DialogParte from '@/components/DialogParte.vue'
import DialogProyecto from '@/components/DialogProyecto.vue'
//import DialogInputHoras from '@/components/DialogInputHoras.vue'
//import DialogInputHorasPersonal from '@/components/DialogInputHorasPersonal.vue'
import DialogSignature from '@/components/DialogSignature.vue'
import DialogSignatureCustomer from '@/components/DialogSignatureCustomer.vue'
import DialogSignatureHourStart from '@/components/DialogSignatureHourStart.vue'
import DialogSignatureHourEnd from '@/components/DialogSignatureHourEnd.vue'
//import DialogParteDetalle from '@/components/DialogParteDetalle.vue'
import DialogExtraInfo from '@/components/DialogExtraInfo.vue'
import DialogSummary from '@/components/DialogSummary.vue'
import DialogDocumentImages from '@/components/DialogDocumentImages.vue'
import DialogLogout from '@/components/DialogLogout.vue'
import SystemBar from '@/components/SystemBar.vue'

export default {
  name: 'app',
  components: {
    //HelloWorld,    
    Toolbar,
    //DialogParte,
    DialogProyecto,
    /*DialogInputHoras,
    DialogInputHorasPersonal,*/
    DialogSignature,
    DialogSignatureCustomer,
    DialogSignatureHourStart,
    DialogSignatureHourEnd,
    //DialogParteDetalle,
    DialogExtraInfo,
    DialogSummary,
    DialogDocumentImages,
    DialogLogout,
    SystemBar
  },
  mounted(){    
    this.getAppConfig();
  }
}
</script>

<style>
.v-list-item {
  padding-left: 2px !important;
}
.v-dialog{
  /*margin: 5px !important;*/
}
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
.systembarFix{
  max-height: 25px;
  margin-top: 56px;  
  z-index: 1;
}
.v-card__title{
  padding: 0px;
}

@media (max-width: 600px) {
  #appContent{    
    padding: 0px 0px 0px !important;
  }
}
/*#headline{
  padding: 0;
  margin: 0px;
  min-width: 10px;  
}
.title{
  min-width: 150px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}*/
</style>
